import { SYS_OPACITY_0_PCT, SYS_OPACITY_100_PCT, SYS_BREAKPOINT_LG, SYS_BREAKPOINT_MD, SYS_BREAKPOINT_XL, SYS_PAGE_MARGIN_LG, SYS_PAGE_MARGIN_MD, SYS_PAGE_MARGIN_XS } from '@oneaudi/unified-web-common';
import styled, { css } from 'styled-components';
import { IconButton } from '../icon-button/index.js';
export const StyledChildrenContainer = styled.div ``;
export const StyledInner = styled.div `
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    position: relative;
  }
`;
export const StyledDialog = styled.dialog `
  @keyframes show {
    from {
      opacity: ${SYS_OPACITY_0_PCT};
      transform: translateY(40px);
    }
    to {
      opacity: ${SYS_OPACITY_100_PCT};
      transform: translateY(0);
    }
  }

  box-sizing: border-box;
  background-color: ${(props) => props.theme.global.color.elevation.level1};
  border: 0;
  padding: ${(props) => props.hasPadding && props.variant === 'alert' ? SYS_PAGE_MARGIN_XS : 0};
  width: 100%;
  max-width: 100%;
  inset-block-start: auto;

  &[open] {
    animation: show 0.42s ease forwards;
  }

  &::backdrop {
    background-color: ${(props) => props.theme.sem.color.ui.surface.scrim.default};
  }

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    inset-block-start: revert;
    padding: ${(props) => props.hasPadding && props.variant === 'alert' ? SYS_PAGE_MARGIN_MD : 0};
    ${(props) => props.variant === 'alert' &&
    css `
        width: 600px;
      `}
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    padding: ${(props) => props.hasPadding && props.variant === 'alert' ? SYS_PAGE_MARGIN_LG : 0};
  }

  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    width: ${(props) => props.variant === 'alert'
    ? '600px'
    : props.variant === 'focus-small'
        ? SYS_BREAKPOINT_MD
        : SYS_BREAKPOINT_LG};
  }

  ${(props) => props.variant !== 'alert' &&
    css `
      ${StyledInner} {
        display: flex;
        flex-direction: column;
        align-items: flex-end;

        ${props.hasPadding &&
        css `
          @media (min-width: ${SYS_BREAKPOINT_MD}) {
            display: block;
          }
        `}

        ${StyledChildrenContainer} {
          width: 100%;
          box-sizing: border-box;

          ${props.hasPadding &&
        css `
            padding: 0 ${SYS_PAGE_MARGIN_XS} ${SYS_PAGE_MARGIN_XS}
              ${SYS_PAGE_MARGIN_XS};

            @media (min-width: ${SYS_BREAKPOINT_MD}) {
              padding: ${SYS_PAGE_MARGIN_MD};
            }

            @media (min-width: ${SYS_BREAKPOINT_LG}) {
              padding: ${SYS_PAGE_MARGIN_LG};
            }
          `}
        }
      }
    `}
`;
export const StyledIconButton = styled(IconButton) `
  ${(props) => props.hasPadding &&
    css `
      @media (min-width: ${SYS_BREAKPOINT_MD}) {
        position: absolute;
        top: 0;
        right: 0;
      }
    `}
`;
//# sourceMappingURL=index.styles.js.map